import React from "react";

interface SharpProps {
  className?: string;
  width?: number;
  fill?: string;
  height?: number;
}
const IconSharp: React.FC<SharpProps> = ({ className, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.667 24q-1.099 0-1.883-.783A2.57 2.57 0 0 1 0 21.333V16h2.667v5.333H8V24zM16 24v-2.667h5.333V16H24v5.333q0 1.099-.783 1.884a2.57 2.57 0 0 1-1.884.783zM0 8V2.667Q0 1.568.784.784A2.57 2.57 0 0 1 2.667 0H8v2.667H2.667V8zm21.333 0V2.667H16V0h5.333q1.099 0 1.884.784.783.783.783 1.883V8zM12 18.667q-2.767 0-4.716-1.951Q5.333 14.767 5.333 12t1.951-4.716Q9.233 5.333 12 5.333t4.716 1.951T18.667 12t-1.951 4.716T12 18.667M12 16q1.667 0 2.833-1.167A3.87 3.87 0 0 0 16 12q0-1.667-1.167-2.833A3.87 3.87 0 0 0 12 8q-1.667 0-2.833 1.167A3.87 3.87 0 0 0 8 12q0 1.667 1.167 2.833A3.87 3.87 0 0 0 12 16"
      fill="#C2282B"
    />
  </svg>
);
export default IconSharp;
